import React from 'react'

const BusinessAnalytics = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={40}
                height={40}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        fill="#d3d3d3"
                        d="M91 32h350v470H91z"
                        opacity={1}
                        data-original="#d3d3d3"
                    />
                    <path
                        fill="#d3d3d3"
                        d="M81 20h350v470H81z"
                        opacity={1}
                        data-original="#d3d3d3"
                    />
                    <path
                        fill="#edeff1"
                        d="M71 10h350v470H71z"
                        opacity={1}
                        data-original="#edeff1"
                        className=""
                    />
                    <path
                        fill="#ffb0aa"
                        d="M116 199h50v80h-50z"
                        opacity={1}
                        data-original="#ffb0aa"
                    />
                    <path
                        fill="#ffe352"
                        d="M186 139h50v140h-50z"
                        opacity={1}
                        data-original="#ffe352"
                    />
                    <path
                        fill="#80d6fb"
                        d="M256 179h50v100h-50z"
                        opacity={1}
                        data-original="#80d6fb"
                        className=""
                    />
                    <path
                        fill="#98ca69"
                        d="M326 99h50v180h-50z"
                        opacity={1}
                        data-original="#98ca69"
                    />
                    <path
                        fill="#6e83b7"
                        d="M396 279v20H96v-20zM236 45v20H96V45zM176 85v20H96V85zM396 335v20H276v-20zM256 335v20h-20v-20zM396 375v20H276v-20zM256 375v20h-20v-20zM396 415v20H276v-20zM256 415v20h-20v-20z"
                        opacity={1}
                        data-original="#6e83b7"
                    />
                    <path
                        fill="#ffb0aa"
                        d="M156 325v60h60c0-33.137-26.863-60-60-60z"
                        opacity={1}
                        data-original="#ffb0aa"
                    />
                    <path
                        fill="#ffe352"
                        d="m156 385 42.426 42.426C209.284 416.568 216 401.569 216 385z"
                        opacity={1}
                        data-original="#ffe352"
                    />
                    <path
                        fill="#98ca69"
                        d="M113.574 427.426C124.431 438.284 139.431 445 156 445s31.569-6.716 42.426-17.574L156 385z"
                        opacity={1}
                        data-original="#98ca69"
                    />
                    <path
                        fill="#80d6fb"
                        d="M113.574 427.426 156 385v-60c-33.137 0-60 26.863-60 60 0 16.569 6.716 31.568 17.574 42.426z"
                        opacity={1}
                        data-original="#80d6fb"
                        className=""
                    />
                </g>
            </svg>

        </>
    )
}

export default BusinessAnalytics